import React, { useEffect, useRef } from 'react';
import ReactInputMask from 'react-input-mask';
import { useField } from '@unform/core';

import { InputContainer } from './styles';

function InputMask({ name, label, ...rest }) {
  const inputRef = useRef(null);
  const { fieldName, registerField, defaultValue, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
      setValue(ref, value) {
        ref.setInputValue(value);
      },
      clearValue(ref) {
        ref.setInputValue('');
      },
    });
  }, [fieldName, inputRef, registerField]);

  return (
    <InputContainer>
      <label htmlFor={fieldName}>{label}</label>
      <ReactInputMask ref={inputRef} defaultValue={defaultValue} {...rest} />
      {error && <span>{error}</span>}
    </InputContainer>
  );
}

export default InputMask;
